















  import { Vue, Component, Prop } from 'nuxt-property-decorator'
  import OneTab from '~/components/atoms/tabs/OneTab.vue'

  @Component({
    components: { OneTab },
  })
  export default class OneTabs extends Vue {
    name: string = 'OneTabs'

    activeTab: string = ''

    @Prop({
      type: Array,
      default: () => [],
    })
    tabs?: any

    @Prop({
      type: String,
      required: true,
    })
    value!: string

    changeActiveTab(tabType: string) {
      this.activeTab = tabType
      this.$emit('input', tabType)
    }

    created() {
      this.activeTab = this.value
    }
  }
